import { useState } from "react";
import InputField from "../../components/shared/input-field";
import { Box,CustomCard, TitleComponent, Avatar, CustomButton } from "ui-components";
import styled from "styled-components";
import { Button } from "@blueprintjs/core";

const MyProfile = () => {
  const [userDetail, setUserDetail] = useState<Record<string, any>>({});

  const onSubmitProfile = (event: any) => {
  };
  const handleOnChange = (event: any) => {
    const { name, value } = event.target;
    const userObj: Record<string, any> = { ...userDetail };
    if (name) userObj[name] = value;
    setUserDetail({ ...userObj });
  };
  return (
    <CustomCard padding="30px 60px">
      <Box flexDir="row" justify="between" items="center">
        <TitleComponent fontSize="24px">Edit Profile </TitleComponent>
        <CustomButton rightIcon="log-out" onClick={() => {}} pd="5px 20px" bradius="5px">
          Logout
        </CustomButton>
      </Box>

      <Box flexDir="row" gap="large">
        <Box width={"auto"} justify="center">
          <ProfileImageContainer>
            <Avatar
              profileUrl={"/images/profile.svg"}
              displayName={"Kishan Madan"}
              email={"yantrix@gmail.com"}
              isCircle={true}
              isCurrentUser={false}
              isLoading={false}
              size={"120px"}
            />
            <PencilIcon>
              <img
                src="/icons/pencil.svg"
                alt="profile edit"
                width="25"
                height="25"
              />
            </PencilIcon>
          </ProfileImageContainer>
        </Box>
        <Box width={"1/2"}>
          <InputField
            label={"Your Name"}
            name={"fullName"}
            type={"text"}
            placeholder={"Kishan Madan"}
            onChange={handleOnChange}
            value={userDetail?.fullName ?? ""}
          />
          <InputField
            label={"Designation"}
            name={"designation"}
            type={"text"}
            placeholder={"Head of Technology"}
            onChange={handleOnChange}
            value={userDetail?.designation ?? ""}
          />
          <InputField
            label={"Company Email"}
            name={"emailId"}
            type={"text"}
            placeholder={"kishanmadan@gmail.com"}
            onChange={handleOnChange}
            value={userDetail?.emailId ?? ""}
          />
          <InputField
            label={"Date of Birth"}
            name={"dob"}
            type={"text"}
            placeholder={"02/02/1999"}
            onChange={handleOnChange}
            value={userDetail?.dob ?? ""}
          />

          <InputField
            label={"City"}
            name={"city"}
            type={"text"}
            placeholder={"Bangalore, Karnataka"}
            onChange={handleOnChange}
            value={userDetail?.address?.city ?? ""}
          />
        </Box>

        <Box width={"1/2"}>
          <InputField
            label={"Use Name"}
            name={"userName"}
            type={"text"}
            placeholder={"Use Name"}
            onChange={handleOnChange}
            value={userDetail?.userName ?? ""}
          />
          <InputField
            label={"Company Name"}
            name={"companyName"}
            type={"text"}
            placeholder={"Apple, NY"}
            onChange={handleOnChange}
            value={userDetail?.companyName ?? ""}
          />
          <InputField
            label={"Phone Number"}
            name={"phoneNumber"}
            type={"text"}
            placeholder={"9898989898"}
            onChange={handleOnChange}
            value={userDetail?.phoneNumber ?? ""}
          />
          <InputField
            label={"Password"}
            name={"password"}
            type={"password"}
            placeholder={"********"}
            onChange={handleOnChange}
            value={userDetail?.password ?? ""}
          />

          <InputField
            label={"Country"}
            name={"country"}
            type={"text"}
            placeholder={"USA"}
            onChange={handleOnChange}
            value={userDetail?.address?.country ?? ""}
          />
        </Box>
      </Box>

      <Box justify="end" mt="large">
        <CustomButton onClick={onSubmitProfile} pd="7px 30px">Save</CustomButton>
      </Box>
    </CustomCard>
  );
};
export default MyProfile;

const PencilIcon = styled.div`
  position: absolute;
  bottom: 10px;
  right: 0;
  cursor: pointer;
`;

const ProfileImageContainer = styled.div`
  position: relative;
  height: fit-content;
  margin-top: 30px;
`;
// const SaveButton = styled(Button)`
//   width: 180px;
//   color: #ffffff;
//   font-size: 18px;
//   background-color: #333333;
//   border-radius: 18px;
//   padding: 15px 30px;
//   cursor: pointer;
//   margin-top: 20px;
//   &:hover {
//     background-color: #5e5e5e;
//   }
// `;

// const LogoutButton = styled(Button)`
//   font-size: 16px;
//   color: #252525;
//   cursor: pointer;
//   background-color: transparent;
//   display: flex;
//   align-items: center;
//   border-radius: 20px;
//   border: 1px solid #555555;
//   padding: 0px 22px;
//   height: 35px;
//   &:hover {
//     background-color: #d3d3d3;
//   }
// `;
